import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from '@/hooks/queries/query-keys';
import { isAlreadyChangedError } from '@/lib/admin-action-error';
import { adminsApi } from '@/lib/api';

/**
 * Revoke an invitation (POST /admins/invitations/:id/revoke). On success the
 * invite is gone and its slot freed; on a 404/409 it already changed under us.
 * Either way we refetch the roster rather than patching the cache, so the table
 * and the remaining-slots indicator reflect server truth (TDEV-140).
 */
export function useRevokeInvitation() {
  const queryClient = useQueryClient();
  const refreshRoster = () =>
    void queryClient.invalidateQueries({ queryKey: queryKeys.admins.roster });
  return useMutation<{ id: string }, Error, string>({
    mutationFn: (invitationId) => adminsApi.revokeInvitation(invitationId),
    onSuccess: refreshRoster,
    onError: (error) => {
      if (isAlreadyChangedError(error)) refreshRoster();
    },
  });
}
